<template>
    <img :src="avatar">
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "AvatarComponent",
    data() {
        return {
            componentType: "avatar",
            rendersWithVue: true,
        };
    },
    computed: {
        ...mapState("user", ["user"]),
        avatar() {
            return (
                window.serverImg +
                "avatars/thumbs/" +
                this.user.id +
                ".jpg" +
                "?version=" +
                encodeURIComponent(nowDateTime())
            );
        },
        avatarStyle(){
          return `background-image: url('${this.avatar}');`
        }
    },
};
</script>
<style lang="scss" scoped>

</style>
